/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: p_fy
 * @Date: 2019-07-19 11:29:53
 * @LastEditTime: 2019-08-26 17:32:14
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  被预约管理接口Url
const findCoverAppointmentListUrl = '/website/storage/appointment'

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}

// 分页查询被预约列表
export function findCoverAppointmentList(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + findCoverAppointmentListUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCoverAppointmentList'
      }, param))
    }
  })
}
// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 修改预约状态
export function updateStatus(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + 'website/storage/appointment',
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'updateStatus'
      }, param))
    }
  })
}
